import SvgImage from './SvgImage';
import G from './Getters';


function getBounds(div,gridOrigin){
  let { x, y, width, height } = div.getBoundingClientRect();

  return {
    x:(x - gridOrigin[0]),
    y:(y - gridOrigin[1]),
    width,
    height
  }


}

function getSvgNode({
  nodeType,
  state,
  nodeDiv,
  figurePanel,
  cell,
  value,
  imageUrlMap,
  exportId,
  gridOrigin,
  download,
}){
  
  let nodeId = nodeDiv.getAttribute("nodeId");

  let imgs = Array.from(nodeDiv.querySelectorAll('img'));

  /*return imgs.map(imgEl => {
    let bounds = imgEl.getBoundingClientRect();
    return (
      <>
      <image fill="pink" src={imgEl.src} 
        width={100}
      height={100}
      x={0 && bounds.x}
      y={20}
        
    />
        <text y={20}>HELLO</text>
      </>
    )
  })

  debugger;
  */


  let figurePanelId = figurePanel._id;
  let cellLocation = cell;
  let node = G.getEvaluatedFigurePanelCellNodeValue(state,{figurePanelId, cellLocation, nodeId});


  let style = node.style;

  let rect = nodeDiv.getBoundingClientRect();
  let bounds = {
    width:rect.width,
    height:rect.height,
    x:rect.x,
    y:rect.y
  }

  if( !gridOrigin ){
    debugger;
  }

  let rx = rect.x - gridOrigin[0];
  let ry = rect.y - gridOrigin[1];


  let stroke = style.borderColor;
  let strokeWidth = style.borderWidth || 1;

  let props = {
    nodeId,
    div:nodeDiv,
    imageUrlMap,
    state,
    value,
    node,
    bounds:{
      x:rx,
      y:ry,
      width:bounds.width,
      height:bounds.height
    },
    cell:cellLocation,
    exportId,
    figurePanel,
    download,
  }



  let imageNode = (

    <>

      {nodeType==="image" && <rect x={rx} y={ry} width={bounds.width} height={bounds.height} {...{
    style,
    fill:"transparent",
    stroke,
    strokeWidth,
  }}/>}

      {nodeType==="image" && <SvgImage {...{...props}}/>}
    {false && <text x={rx} y={ry} fill={"blue"}> {nodeId} </text>}


  </>
  )

  let computedStyle = window.getComputedStyle(nodeDiv); 
  let outlineWidth = Number(computedStyle.outlineWidth?.split('px')?.[0] || 0);

  console.log("outlineWidth = " + outlineWidth);
  
  let outline = nodeType === "scalebar" && (
    <rect 
      x={rx - 0.5 * outlineWidth}
      y={ry - 0.5 * outlineWidth}
      width={bounds.width + 1.5 * outlineWidth}
      height={bounds.height + 1.5 * outlineWidth}
      // + 3 * outlineWidth} 
  {...{
      style,
      fill:"transparent",
      stroke,
      strokeWidth:outlineWidth,
    }}/>
  )



  let textNodesEls = Array.from(nodeDiv.querySelectorAll("[component=text]"));

  let svgTextNodes = textNodesEls.map((el,ii) => getExpansionTextNode(
    el,ii,{state,figurePanelId,cellLocation,gridOrigin}
  ));

  return [
    imageNode,
    svgTextNodes,
    outline,
  ];

  


}

function getExpansionTextNode(textNode,iiText,{state,figurePanelId,cellLocation,gridOrigin}){

  let textNodeId = textNode.getAttribute("nodeId");

  let textBounds = getBounds(textNode,gridOrigin);
  let evaluatedTextNode = G.getEvaluatedFigurePanelCellNodeValue(state,{figurePanelId,cellLocation,nodeId:textNodeId});


  console.log("LABEL = " + evaluatedTextNode.label);


  let textStyle = evaluatedTextNode.style;
  const rectHeight = (textStyle.fontSize || 12) + 1;
  let node = (
    <>

      <rect x={textBounds.x} y={textBounds.y} 
        width={textBounds.width} 
        height={ rectHeight } 
        fill={textStyle.background}
        />
      <text dominantBaseline={"middle"} 
        x={textBounds.x + 1}
        y={(textBounds.y||0)+1 + rectHeight/2}
        style={{

          fontSize:12,
          fontFamily:(textStyle.fontFamily || "Helvetica"),
          ...(textStyle||{}),
          
        }}
        fill={textStyle.color}
        //fontFamily={"Helvetica Neue"}
        //fontSize={"12px"}
        //style={textStyle}
      >{evaluatedTextNode.label}</text>

    </>
  )

  return node;
}



export default function SvgExpansion({div,gridOrigin,value,state,cell,imageUrlMap, figurePanel, exportId, download }){

  let {x,y,width,height} = div.getBoundingClientRect();
  let imageContainers = Array.from(div.querySelectorAll("[component=layoutvalueimage]")).map(el => ({type:"image",el}));

  let scalebarContainers = Array.from(div.querySelectorAll("[item=container]")).map(el => ({type:"scalebar",el}));

  console.log(scalebarContainers);

  let nodeContainers = [
    ...imageContainers,
    ...scalebarContainers,
  ]

  let top = y - gridOrigin[1];
  let left = x - gridOrigin[0]

  let panel = figurePanel
  let svgNodes = [];
  for(let ii = 0; ii < nodeContainers.length; ii++){
    let elInfo = nodeContainers[ii];
    let nodeDiv = elInfo.el;
    let nodeType = elInfo.type;

    console.log('$nd', nodeDiv);
    let bounds = nodeDiv.getBoundingClientRect();

    let svgNode = getSvgNode({
      gridOrigin,
      figurePanel,

      cell,

      imageUrlMap,


      state,
      value,
      nodeType,
      nodeDiv,
      exportId,
      download,
    })
    svgNodes.push((

      <>
        {svgNode}
        {false && <rect x={bounds.x} y={bounds.y}
          width={bounds.width}
          height={bounds.height}
          stroke="red"
        />}
      </>
    ));

  }



  return svgNodes;



}

